export const parseTimeStringToDate = timeString => {
    if (!timeString || typeof timeString !== 'string' || !timeString.includes(':')) return null;
    const [hours, minutes] = timeString.split(':').map(Number);
    if (Number.isNaN(hours) || Number.isNaN(minutes)) return null;
    const date = new Date();
    date.setHours(hours, minutes, 0, 0);
    return date;
};
